import { inject, Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { CommonProcessTreeQueryComplexInput, CommonProcessTreeSortInput, DownloadEvaluationRiskViewGQL, DownloadEvaluationRiskViewMutation, ProcessParameter } from '../../../graphql/generated';
import { convertLazyLoadToComplexWithoutPage } from './riskmap.service';

@Injectable({
    providedIn: 'root'
})
export class EvaluationRiskService {
    private readonly DownloadEvaluationRiskViewGQL: DownloadEvaluationRiskViewGQL = inject(DownloadEvaluationRiskViewGQL);

    loadEvaluationRisk(campaignId: string, riskId: string, parameters: any): Observable<any> {
        return of({})
        // const param = convertLazyLoadToComplexWithoutPage(parameters);
        // return this.RiskEvaluationRiskViewByCampaignIdAndRiskIdGQL.watch(
        //     {
        //         campaignId,
        //         riskId,
        //         query: param.query as CptQueryComplexInput,
        //         sort: param.sort as CptCatalogueSortInput
        //     }, {
        //     fetchPolicy: 'no-cache',
        // }).valueChanges.pipe(map(result => result.data?.riskEvaluationRiskViewByCampaignIdAndRiskId));
    }
    getEvaluationName(): Observable<ProcessParameter[]> {
        return of([] as ProcessParameter[])
    }


    downloadEvaluationRisk(
        campaignId: string,
        riskId: any,
        valueChain: string,
        parameters: any,
        timeZone: string
    ): Observable<DownloadEvaluationRiskViewMutation['downloadEvaluationRiskView']> {
        const param = convertLazyLoadToComplexWithoutPage(parameters);
        return this.DownloadEvaluationRiskViewGQL.mutate({ campaignId, riskId, timeZone, valueChain, query: param.query as CommonProcessTreeQueryComplexInput, sort: param.sort as CommonProcessTreeSortInput }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data?.downloadEvaluationRiskView))
    }
}
